import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LivenessCheck from './components/LivenessCheck';
import SessionView from './components/liveness/SessionView';

const App: React.FC = () => {
  return (
    <Router>
      <Routes>
        <Route path="/liveness/:sessionId" element={<LivenessCheck />} />
        <Route path="/session/:sessionId" element={<SessionView />} />
      </Routes>
    </Router>
  );
};

export default App;
